/**
 * new-password-server-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

import { IncomingMessage } from "../../general/incoming-message";
import { MessageTag } from "../../message-tag";

/**
 * When a client successfully completes the password reset process, the
 * server sends a {@link NewPasswordServerRequest}. The client's reply should
 * be a {@link NewPasswordClientResponse} bearing the requested replacement
 * password.
 *
 * ALTERNATIVELY, the server may send this message after the client succeeds in
 * authenticating in order to indicate that the user must change their password
 * before finishing the authentication process.
 */
export class NewPasswordServerRequest extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.SREQ_NEW_PASSWORD;
	public static tag : MessageTag = MessageTag.SREQ_NEW_PASSWORD;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/auth/credentials/new-password-server-request.ts